import React from 'react'
import * as yup from 'yup'

import { addUrlProps, UrlQueryParamTypes } from 'react-url-query'
import PropTypes from 'prop-types'
import isEqual from 'lodash/isEqual'
import extend from 'lodash/extend'

const configSchema = yup.object().shape({
	usePagination: yup.boolean().default(true),
	useSearch: yup.boolean().default(true),
	useSort: yup.boolean().default(true),
	filters: yup.array().default([]),
	defaults: yup.object(),
})

const queryPropPresets = {
	usePagination: {
		page: { type: UrlQueryParamTypes.number },
		limit: { type: UrlQueryParamTypes.number },
	},
	useSort: {
		sortBy: { type: UrlQueryParamTypes.string },
		sortDir: { type: UrlQueryParamTypes.string },
	},
	useSearch: {
		search: { type: UrlQueryParamTypes.string },
	},
}

// HoC generator
export default function UseQuery(config) {

	config = configSchema.validateSync(config)

	var urlPropsQueryConfig = {};
	
	var defaultProps = {
		page: 1,
		limit: 50,
		sortBy: 'name',
		sortDir: 'asc',
		search: '',
	}

	// apply defaults according to config
	defaultProps = Object.assign(defaultProps, config.defaults);

	var propTypes = {
		// Base query variables
		page: PropTypes.number.isRequired,
		limit: PropTypes.number.isRequired,
		sortBy: PropTypes.string.isRequired,
		sortDir: PropTypes.oneOf(['asc','desc']).isRequired,
		search: PropTypes.string,
		// User specific query variables
	};

	// check queryPropPresets settings
	Object.keys(queryPropPresets).forEach(presetKey => {
		if(config[presetKey]) {
			urlPropsQueryConfig = extend(urlPropsQueryConfig, queryPropPresets[presetKey]);
		}
	})

	// add additional filters to url props config
	config.filters.forEach(filter => {
		// convert value to url schema
		var value = { type: UrlQueryParamTypes[ filter.returnType ? filter.returnType : 'string' ] };
		// add to url props
		urlPropsQueryConfig[filter.name] = value;
		// add default to default props
		defaultProps[filter.name] = filter.default ? filter.default : '';
		// add returnType to prop types
		propTypes[filter.name] = PropTypes[ filter.returnType ? filter.returnType : 'string'];
	})


	// HoC
	
	return function queryableHOC(WrappedComponent) {

		@addUrlProps({urlPropsQueryConfig})
		class Query extends React.Component {

			static defaultProps = defaultProps;

			static propTypes = propTypes;

			constructor(props) {
				super(props);

				// TODO: remove this hacky nonsense
				const query = this.currentQuery;
				for(var v of ['client','jobType', 'jobTypes', 'approvedBy']) {
					if(query[v]) {
						query[v] = null;
					}
				}
				// delete query.client;
				// delete query.jobType;
				// delete query.jobTypes;
				// delete query.approvedBy
				// this.props.onChangeUrlQueryParams({ ...this.currentQuery, client: null });
				this.props.onChangeUrlQueryParams(query);

			}

			get currentQuery() {
				return this.extractQueryProps(this.props);
			}

			get cleanedQuery() {
				// TODO: remove this
				// workaround to circumvent loading ID based filters
				// on load. ideally should make ResourceIDField support 
				// loading initialValue properly
				const excludedKeys = [ 'client', 'jobType', 'approvedBy', 'jobTypes' ];
				return Object.entries(this.currentQuery).reduce((o, [key, value]) => {
					return {...o, [key]: !excludedKeys.includes(key) ? value : null};
				}, {})
			}

			// componentDidMount() {
			// 	// TODO: remove cleanedQuery from here (use currentQuery and fix loading ID fields)
			// 	this.props.onChangeUrlQueryParams(this.currentQuery);
			// }

			// Helpers
			
			extractQueryProps(props) {
				// extract query values from supplied props
				const query = {};
				Object.keys(urlPropsQueryConfig).forEach(k => {

					let propExists = props.hasOwnProperty(k);
					let isEmptyString = typeof props[k] === 'string' && !props[k].length;
					let isAny = props[k] === 'any';

					if(propExists && !isEmptyString && !isAny) {
						query[k] = props[k] 
					}

				});

				return query;
			}
			
			queryChanged(prevProps, currentQuery=undefined) {
				currentQuery = currentQuery ? currentQuery : this.currentQuery;
				var prevQuery = this.extractQueryProps(prevProps);
				
				return !isEqual(prevQuery, currentQuery)
			}

			// Render

			render() {
				return (
					<WrappedComponent {...this.props} 
						queryChanged={::this.queryChanged}
						currentQuery={this.currentQuery}
					/>
				)
			}

		}

		return Query;

	}

}


// WEBPACK FOOTER //
// ./src/connects/query.jsx